import { Meetingroom } from '../../../../../../../interfaces/interfaces';
import VyModal from '../../../../../../common/VyModal';
import { StudioConfiguration } from '../../../../../pageBuilder/Settings/stage/studio/StudioConfiguration';

export const PresentationLivestreamSettingsModal = ({
  open,
  studio,
  onClose,
  onUpdate,
}: {
  open: boolean;
  studio: Meetingroom;
  onClose: () => void;
  onUpdate: () => void;
}) => {
  return (
    <VyModal open={open} onClose={onClose} style={{ width: '30vw' }}>
      {() => <StudioConfiguration studio={studio} onClose={onClose} onUpdate={onUpdate} isPresentationStudio />}
    </VyModal>
  );
};
